import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import NoticeList from '../../components/noticemng/NoticeList'
import NoticeListBox from '../../components/noticemng/NoticeListBox'
import { listNotices, unloadNotices } from '../../modules/noticeModule/notices';

const NoticeListContainer = ({ searchData, onSearch, selectedNotice, handleAdd }) => {



    const dispatch = useDispatch();

    const { notices, error, loading } = useSelector(
        ({ noticeModule, loading }) => ({
            notices: noticeModule.notices.notices,
            error: noticeModule.notices.error,
            loading: loading['notice/LIST_NOTICES'],
        }),
    );

    useEffect(() => {
        if (searchData !== null) {
            dispatch(listNotices(searchData));
        } else {
            dispatch(listNotices());
        }


        return () => {
            dispatch(unloadNotices());
        }
    }, [searchData])

    const handleDown = (event, params) => {
        event.ignore = true;
        const link = document.createElement('a');
        link.href = params.row.wrfileUrl;
        link.download = true;
        link.target = "_blank";
        link.rel = "noopener noreferrer"

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
    }

    const initialValues = {
        searchKeyword: "wrTitle",
        searchWords: "",
    };


    const validationSchema = yup.object({
        searchKeyword: yup.string('').nullable(),
        searchWords: yup.string('').trim().nullable(),
    });

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);

            let searchData = {
                [values.searchKeyword]: values.searchWords,
            }

            setTimeout(() => {
                // alert(JSON.stringify(values, null, 2));
                onSearch(searchData);
                // formik.resetForm();
                setSubmitting(false);
            }, 1000);
        },
    });

    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: 'ID',
                hide: true,
                type: 'string',
                editable: false,
                sortable: false,
            },
            {
                field: 'wrUuid',
                hide: true,
                type: 'string',
                editable: false,
                sortable: false,
            },

            {
                field: 'wrTitle',
                headerName: '제목',
                minWidth: 300,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'left',
                disableClickEventBubbling: true,
                renderCell: (params) => (
                    <div>
                        {params.value}
                        {params.row.wrFileCnt !== '0' && (
                            <Button variant="contained" size="small" sx={{ mx: 2 }} onClick={(e) => handleDown(e, params)}>download</Button>
                        )}
                    </div>
                )
            },

            {
                field: 'wrStartDt',
                headerName: '게시 시작일',
                minWidth: 120,
                flex: 0.6,
                type: 'string',
                editable: false,
                align: 'center',
                headerAlign: 'center',
            },
            {
                field: 'wrEndDt',
                headerName: '게시 종료일',
                minWidth: 120,
                flex: 0.6,
                type: 'string',
                editable: false,
                align: 'center',
                headerAlign: 'center',
            },
            {
                field: 'useYn',
                headerName: '사용유무',
                minWidth: 80,
                flex: 0.3,
                type: 'boolean',
                editable: true,
            },
            {
                field: 'crtNm',
                headerName: '작성자',
                minWidth: 80,
                flex: 0.3,
                type: 'string',
                editable: false,
            },
            {
                field: 'crtDt',
                headerName: '작성일',
                minWidth: 150,
                flex: 0.8,
                type: 'string',
                editable: false,
            },
        ],
        [],
    );

    const handleRowClick = (e, param) => {
        if (!e.ignore) {
            selectedNotice(param.row);
        }

    };
    return (
        <div>
            <NoticeListBox formik={formik} handleAdd={handleAdd} />
            <NoticeList
                columns={columns}
                rows={notices}
                loading={loading}
                handleRowClick={handleRowClick}
                  columnVisibilityModel={{
                    // Hide columns status and traderName, the other columns will remain visible
                    id: false,
                    wrUuid: false,
                //    traderName: false,
                  }}
            />
        </div>
    )
}

export default NoticeListContainer